export default "__VITE_ASSET__CeOdBohw__"